import {useTranslation} from "react-i18next";
import account from "@/assets/account.svg";
import classNames from "classnames";
import styles from "./customer-head.module.scss";
import {useServices} from "@/services-context";
import CustomerActions from "../customer-actions";
import {FixDropdownHead} from "../fix-dropdown-head";
import {LayoutStyleTypes} from "@/util-react/layout";
import {Popup} from "@/uikit";
import React from "preact/compat";
import {useCallback, useRef, useState} from "preact/hooks";

export interface CustomerHeadProps {
    labelClassName?: string;
}

export const CustomerHead: React.FC<CustomerHeadProps> = ({labelClassName}) => {
    const {t} = useTranslation();
    const services = useServices();
    const [visible, setVisible] = useState(false);
    const anchorRef = useRef<HTMLDivElement>(null);
    const customerChannel = services?.customerChannel;

    const label =
        customerChannel && typeof customerChannel.isCustomerAuth === "function" && customerChannel.isCustomerAuth()
            ? customerChannel.customer?.email || ""
            : t("7e19h22khwn365zm.sign-in", "Sign in");

    const handleToggle = useCallback(() => setVisible((v) => !v), []);
    const handleClose = useCallback(() => setVisible(false), []);

    return (
        <div className={styles.customerHeadRoot}>
            <div ref={anchorRef}>
                <FixDropdownHead className={classNames(styles['dropdown-head'], labelClassName)} iconWidth={20}
                                 icon={account} label={label} onClick={handleToggle}/>
            </div>
            <Popup
                anchor={anchorRef.current ?? (undefined as Element | undefined)}
                placement="bottom"
                distance={10}
                arrow
                active={visible}
                className={styles.popup}
                onClose={handleClose}
            >
                <div className={styles.customerPopupContainer}>
                    <CustomerActions type={LayoutStyleTypes.TYPE_LG}/>
                </div>
            </Popup>
        </div>
    );
};

export default CustomerHead;
